import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a7cc7f4e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 0,
  class: "toggle-wrap"
}
const _hoisted_3 = { class: "toggle-wrap__text" }
const _hoisted_4 = { class: "description" }
const _hoisted_5 = {
  key: 1,
  class: "toggle-wrap"
}
const _hoisted_6 = { class: "toggle-wrap__text" }
const _hoisted_7 = { class: "description" }
const _hoisted_8 = { class: "shared-area" }
const _hoisted_9 = { class: "shared-wrapper" }
const _hoisted_10 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_switch = _resolveComponent("el-switch")!

  return (!_ctx.isNetwork)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (!_ctx.isNetwork)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_component_el_switch, {
                modelValue: _ctx.driveStore.currentCase.publicAccessed,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.driveStore.currentCase.publicAccessed) = $event)),
                "before-change": _ctx.makeCaseExternalAccessed,
                loading: _ctx.publicAccessUpdating,
                "active-color": "#13ce66"
              }, null, 8, ["modelValue", "before-change", "loading"]),
              _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$localize('drive.public.cases.share.community')), 1)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$localize('drive.public.cases.share.community.description')), 1),
        (!_ctx.isNetwork)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createVNode(_component_el_switch, {
                modelValue: _ctx.driveStore.currentCase.accessedByExternalUrl,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.driveStore.currentCase.accessedByExternalUrl) = $event)),
                "before-change": _ctx.changeAccessByUrl,
                loading: _ctx.urlAccessUpdating,
                "active-color": "#13ce66"
              }, null, 8, ["modelValue", "before-change", "loading"]),
              _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$localize('drive.public.cases.share')), 1)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$localize('drive.public.cases.share.description')), 1),
        _withDirectives(_createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("input", {
              class: "shared-link",
              value: _ctx.caseUrl
            }, null, 8, _hoisted_10),
            _createElementVNode("div", {
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onCopy && _ctx.onCopy(...args))),
              class: "email"
            }, [
              _createElementVNode("i", {
                class: _normalizeClass(["icon icon-copy-content", _ctx.copied ? 'icon-copy-content-success' : 'icon-copy-content'])
              }, null, 2)
            ])
          ]),
          _createElementVNode("div", null, [
            (_ctx.mainStore.isMobile)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 0,
                  class: "icon icon-share",
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.shareLink && _ctx.shareLink(...args)))
                }))
              : _createCommentVNode("", true)
          ])
        ], 512), [
          [_vShow, _ctx.driveStore.currentCase.accessedByExternalUrl]
        ])
      ]))
    : _createCommentVNode("", true)
}